import React from 'react';
import manualPDF from "../../assets/manualPDF.pdf";
import pdfIcon from "../../assets/images/pdfIcon.jpg";

const trainingVideos = [
    { id: 't4PRQuBsEgM', title: 'Module 1: Introduction & Basics' },
    { id: 'aMAln_3c6Ek', title: 'Module 2: Conditional Formatting' },
    { id: 'glabWegHQsg', title: 'Module 3: Build a Form with Federated' },
    // Add more trainingVideos as needed
];

const troubleshootingVideos = [
    { id: '4Rgn9j81-ao', title: 'Troubleshooting: Multiple Selection Checkbox' },
    { id: 'YJM158CEd1c', title: 'Troubleshooting: Making Form Components Required' },
    { id: 'kh48rLPBa8I', title: 'Troubleshooting: Multiple Signatures Dependent on Crew Members'}
    // Add more trainingVideos as needed
];

const HelpResources = () => {
    return (
        <div>
            {/* Header section */}
            <div style={styles.header}>
                <p style={styles.headerSubtitle}>Form Builder How To Guidance</p>
            </div>
            <div style={styles.grid}>
                {trainingVideos.map((video) => (
                    <a
                        key={video.id}
                        href={`https://www.youtube.com/watch?v=${video.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.link}
                    >
                        <div style={styles.iconContainer}>
                            <img
                                src={`https://img.youtube.com/vi/${video.id}/0.jpg`}
                                alt={video.title}
                                style={styles.icon}
                            />
                        </div>
                        <p style={styles.title}>{video.title}</p>
                    </a>
                ))}
            </div>
            <div style={styles.header}>
                <p style={styles.headerSubtitle}>Form Builder TroubleShooting</p>
            </div>
            <div style={styles.grid}>
                {troubleshootingVideos.map((video) => (
                    <a
                        key={video.id}
                        href={`https://www.youtube.com/watch?v=${video.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.link}
                    >
                        <div style={styles.iconContainer}>
                            <img
                                src={`https://img.youtube.com/vi/${video.id}/0.jpg`}
                                alt={video.title}
                                style={styles.icon}
                            />
                        </div>
                        <p style={styles.title}>{video.title}</p>
                    </a>
                ))}
            </div>
            <div style={styles.header}>
                <p style={styles.headerSubtitle}>Form Builder Resource PDFs</p>
            </div>
            {/* PDF Icon with Label */}
            <div style={styles.pdfIconContainer}>
                <a
                    href={manualPDF}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.pdfLink}
                >
                    <div style={styles.pdfIconBox}>
                        <img
                            src={pdfIcon}
                            alt="PDF icon"
                            style={styles.pdfIcon}
                        />
                        <p style={styles.pdfLabel}>Form Builder Component Cheat Sheets</p>
                    </div>
                </a>
            </div>

        </div>

    );
};

const styles: { [key: string]: React.CSSProperties } = {
    header: {
        backgroundColor: '#f0f0f0',
    },
    headerTitle: {
        margin: 0,
        fontSize: '24px',
        fontWeight: 'bold',
    },
    headerSubtitle: {
        margin: '8px 0 0',
        fontSize: '16px',
        color: '#666',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', // Increased min width
        gap: '20px',
        padding: '16px',
    },
    link: {
        textDecoration: 'none',
        color: 'inherit',
        textAlign: 'center' as React.CSSProperties['textAlign'],
        display: 'block',
    },
    iconContainer: {
        width: '100%',
        paddingBottom: '56.25%', // 16:9 aspect ratio
        position: 'relative',
        backgroundColor: '#000',
        borderRadius: '8px',
        overflow: 'hidden',
    },
    icon: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover' as React.CSSProperties['objectFit'],
    },
    title: {
        marginTop: '12px', // Increased spacing below thumbnail
        fontSize: '12px', // Smaller font size
        fontWeight: 400,   // Less bold
    },
    pdfIconContainer: {
        marginTop: '32px',
      },
      
      pdfLink: {
        textDecoration: 'none',
        color: 'inherit',
        display: 'inline-block',
      },
      
      pdfIconBox: {
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.2s ease',
      },
      
      pdfIcon: {
        width: '80px',
        height: '80px',
      },
      
      
      pdfLabel: {
        marginTop: '8px',
        fontSize: '14px',
        fontWeight: 500,
        color: '#333',
      },
      
};

export default HelpResources;
